module.exports = __webpack_public_path__ + "img/skripsi-created.0470ac6d.png";